import { render, staticRenderFns } from "./LawProductCategoryForm.vue?vue&type=template&id=d16d9344&"
import script from "./LawProductCategoryForm.vue?vue&type=script&lang=js&"
export * from "./LawProductCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./LawProductCategoryForm.vue?vue&type=style&index=0&id=d16d9344&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports